(function(root) {
 function buildItems({variantId,quantity,deliveryId,terminalId,group}) {
  const id=Number(variantId),qty=Number(quantity);
  if (!Number.isSafeInteger(id)||id<=0||!Number.isInteger(qty)||qty<1) throw Error('Choose a valid quantity and machine configuration.');
  const items=[{id,quantity:qty,properties:{_configuration:group}}];
  for (const addon of [deliveryId,terminalId]) {
   if (!addon) continue;
   const aid=Number(addon); if (!Number.isSafeInteger(aid)||aid<=0||aid===id) throw Error('The selected add-on is unavailable.');
   items.push({id:aid,quantity:qty,parent_id:id,properties:{_configuration:group}});
  }
  return items;
 }
 if (typeof module !== 'undefined' && module.exports) module.exports={buildItems};
 if (!root.document) return;
 root.DSVMachineOrder={buildItems};
 // Inspect specifications in a native modal without changing the configuration.
 document.addEventListener('click',event=>{
  const trigger=event.target.closest('[data-terminal-spec-name]');if(!trigger)return;
  const group=trigger.closest('.machine-terminals');if(!group)return;
  let panel=group.querySelector('[data-terminal-spec-panel]');
  if(!panel){
   panel=document.createElement('dialog');panel.className='terminal-spec-panel';panel.dataset.terminalSpecPanel='';panel.id=group.closest('form').getAttribute('id')+'-terminal-specs';
   const header=document.createElement('div');header.className='terminal-spec-panel__header';
   const title=document.createElement('h3');title.id=panel.id+'-title';panel.setAttribute('aria-labelledby',title.id);
   const close=document.createElement('button');close.type='button';close.className='terminal-spec-panel__close';close.textContent='Close ×';close.setAttribute('aria-label','Close terminal specifications');
   const content=document.createElement('div');content.className='terminal-spec-panel__body';header.append(title,close);panel.append(header,content);group.append(panel);
   close.addEventListener('click',()=>panel.close());
   panel.addEventListener('click',e=>{const r=panel.getBoundingClientRect();if(e.target===panel&&(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom))panel.close();});
   panel.addEventListener('close',()=>{const opener=group.querySelector('[data-terminal-spec-name][aria-expanded="true"]');opener?.setAttribute('aria-expanded','false');opener?.focus();});
  }
  const source=trigger.closest('.terminal-choice').querySelector('[data-terminal-spec-content]');
  panel.querySelector('h3').textContent=trigger.dataset.terminalSpecName;
  const content=panel.querySelector('.terminal-spec-panel__body');content.replaceChildren();
  const image=trigger.closest('.terminal-choice').querySelector('.terminal-choice__image img');
  if(image){const photo=image.cloneNode();photo.className='terminal-spec-panel__image';photo.alt=trigger.dataset.terminalSpecName;content.append(photo);}
  content.append(source.content.cloneNode(true));
  trigger.setAttribute('aria-controls',panel.id);trigger.setAttribute('aria-expanded','true');
  panel.showModal();
 });
 function refresh(form) {
  const host=form.querySelector('[data-machine-order]'); if(!host)return;
  const delivery=host.querySelector('[data-delivery-option]');
  host.querySelector('[data-curbside-copy]').hidden=!!delivery.value;
  host.querySelector('[data-white-glove-copy]').hidden=!delivery.value;
  const variants=JSON.parse(form.querySelector('[data-product-variants]').textContent);
  const variant=variants.find(v=>String(v.id)===form.querySelector('[data-variant-id]').value);
  const terminal=host.querySelector('[data-terminal-option]:checked');
  const extras=Number(delivery.selectedOptions[0]?.dataset.price||0)+Number(terminal?.dataset.price||0);
  const qty=Number(form.querySelector('[name="quantity"]').value);
  const total=(Number(variant?.priceCents||0)+extras)*qty;
  const output=host.querySelector('[data-order-total]');
  output.textContent=Number.isFinite(total)&&qty>0 ? 'Configuration subtotal: '+new Intl.NumberFormat(document.documentElement.lang||'en',{style:'currency',currency:form.dataset.currency||'USD'}).format(total/100) : '';
 }
 document.addEventListener('change',e=>{const form=e.target.closest('[data-product-form]');if(form)refresh(form);});
 document.addEventListener('input',e=>{if(e.target.matches('[name="quantity"]')){const form=e.target.closest('[data-product-form]');if(form)refresh(form);}});
 document.querySelectorAll('[data-product-form]').forEach(refresh);
 const cart = document.querySelector('[data-configured-cart]');
 if (cart) {
  function syncChildren() {
   const inputs = [...cart.querySelectorAll('[data-line-key]')];
   const parents = new Map(inputs.map(input => [input.dataset.lineKey, input]));
   inputs.filter(input => input.dataset.parentKey).forEach(input => {
    const parent = parents.get(input.dataset.parentKey);
    if (parent) input.value = parent.value;
   });
  }
  cart.addEventListener('input', syncChildren);
  cart.addEventListener('submit', syncChildren);
  syncChildren();
 }
})(typeof window!=='undefined'?window:globalThis);
